import React from 'react';

import styles from './SignInPage.module.css';

type TProps = {
  children: React.ReactNode;
};

export const SignInPageFieldset = ({ children }: TProps) => (
  <div className={styles.SignInPage__Fieldset}>{children}</div>
);
